// LIBRERIE/IMPORTS
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface Agent {
    img: string;
    name?: string;
    tel?: string;
    mobile?: string;
    email?: string;
}

interface AgentsSectionProps {
    showAgents: boolean;
    agents: Agent[];
    agentsLoading: boolean;
    agentsError: string | null;
}

const AgentsSection: React.FC<AgentsSectionProps> = ({ showAgents, agents, agentsLoading, agentsError }) => {
    const { t } = useTranslation();

    const handMadeAgents: Agent[] = [
        {
            img: "/assets/images/team/agent1.jpg",
        },
        {
            img: "/assets/images/team/agent2.jpg",
        }
    ];

    let finalAgentList: Agent[] = handMadeAgents;

    const [activeIndex, setActiveIndex] = useState(0);
    const agentCount = agents.length;

    console.log(activeIndex);

    // Carosello x agenti
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex(prev => (prev>agentCount - 1 ? 0 : prev + 1));
        }, 5000);

        return () => clearInterval(interval);
    }, [agentCount]);

    if (!showAgents) return null;

    return (
        (agentsLoading || agentsError || agents.length > 0) ? (
            <section className="agent-widget">
                {agentsLoading ? (
                    <div className="text-center">{t('agents.loadingAgents')}...</div>
                ) : agentsError ? (
                    <div className="text-center text-danger">{agentsError}</div>
                ) : (
                    <div className="row no-gutters justify-content-center mt-5">
                        <h4 className="w-100">{t('agents.sectionTitle')}</h4>
                        {finalAgentList.map((agent, index) => (
                            <div key={index} className={`agent-card ${index == activeIndex ? "" : "d-none"}`} style={{ backgroundImage: `url(${agent.img})` }}>

                            </div>
                        ))}
                    </div>
                )}
            </section>
        ) : null
    );
};

export default AgentsSection;